import { custom, schema, string } from "@anna-money/anna-web-lib/serializer";

// Flow config answer structure
export interface SoleTraderQuestionnaireAnswer {
  id: string;
  answer: string;
  nextQuestionId: string;
  outcomeId: string;
  outcomeText: string | null;
}

// Flow config question structure
export interface SoleTraderQuestionnaireQuestion {
  id: string;
  question: string;
  answersType: "radio" | "select" | "input";
  answers: Record<string, SoleTraderQuestionnaireAnswer>;
}

// Flow config structure - this is the direct API response
export interface SoleTraderQuestionnaireConfig {
  firstQuestionId: string;
  questions: Record<string, SoleTraderQuestionnaireQuestion>;
}

export class SoleTraderQuestionnaireResponseData extends schema(
  {
    firstQuestionId: string(),
    questions: custom<Record<string, SoleTraderQuestionnaireQuestion>>(
      "Questions",
      (value: unknown) => value as Record<string, SoleTraderQuestionnaireQuestion>,
      (questions: Record<string, SoleTraderQuestionnaireQuestion>) => questions as any,
    ),
  },
  "SoleTraderQuestionnaireResponseData",
) {}
